// @flow
import { UI_RESET_FACET_STATE, UI_SET_FACET_STATE } from '../reducers/ui';

const resetFacetState = () => ({
  type: UI_RESET_FACET_STATE
});

const setFacetState = (facet: string, value: boolean) => ({
  type: UI_SET_FACET_STATE,
  payload: {
    facet,
    value
  }
});

export { resetFacetState, setFacetState };



// WEBPACK FOOTER //
// ./src/actions/ui.js